<!--<h1>my app</h1>

<nav>
  <a class="button" routerLink="/">Home</a> |
  <a class="button" routerLink="/login">Login</a> 
</nav>
-->
<router-outlet></router-outlet>

<!--<app-block1></app-block1>-->